import { Box, List, ListItem } from '@chakra-ui/react';
import type { JunipRatingDistribution } from 'types/reviews';

import { ReviewRatingBar } from '../ReviewsRatingBar';

export interface ProductRatingDistributionProps {
  ratingDistribution: JunipRatingDistribution;
  totalReviews: number;
  ratingFilter?: string;
  setRatingFilter: (rating: string | null) => void;
}

export function ProductRatingDistribution({
  ratingDistribution,
  totalReviews,
  ratingFilter,
  setRatingFilter,
}: ProductRatingDistributionProps) {
  return (
    <List display="flex" flexDir="column" gap="5xs" mt="sm">
      {Object.entries(ratingDistribution)
        .reverse()
        .map(([key, val]) => (
          <ListItem key={key}>
            <Box
              as="button"
              type="button"
              display="block"
              width="100%"
              textAlign="left"
              cursor="pointer"
              aria-label={`Filter reviews by ${key} star rating`}
              aria-pressed={ratingFilter === key}
              onClick={() => setRatingFilter(ratingFilter === key ? null : key)}
            >
              <ReviewRatingBar
                rating={key}
                amount={val as number}
                total={totalReviews}
                isInactive={!!(ratingFilter && ratingFilter !== key)}
              />
            </Box>
          </ListItem>
        ))}
    </List>
  );
}
